import { Component, OnInit } from '@angular/core';
import {AhmService} from '../../services/ahm.service';
import {TranslateService} from '../../services/translate.service';

@Component({
  selector: 'main-page', // this is into main html <employee-list></employee-list>
  templateUrl: './main-page.component.html',
  styleUrls: ['./main-page.component.css']
})
export class MainPageComponent implements OnInit {

  public employees = [];
  // about book
  version = 'eng';
  homePageLogo = '';
  alphabet = '';
  human = '';
  mind = '';
  subtitle = '';
  authors = '';

  constructor() {

    // console.log('AhmService.prototype.setThis(this);', this);

    //
    // console.log(" CONSTRUCTOR 1 --------->  ", this.employees);
    //
    // this.employees = ['Emp1', 'Emp2'];
    //
    // console.log(" CONSTRUCTOR 2 --------->  ", this.employees);
    //
    // // console.log('data ----> ', data);

    // this.homePageLogo = 'assets/images/kompas1339ENG.png';
    // this.alphabet = 'ALPHABET OF';
    // this.human = 'THE HUMAN';
    // this.mind = 'MIND';
    // this.subtitle = 'psychology flagship';
    // this.authors = 'Nikita M. Danilov and Ekaterina V. Danilova ©';

  }

  ngOnInit() {
    // try to take data from json
    // this._employeeService.getEmployees().subscribe(data => this.employees = data);
    AhmService.prototype.setMainContentComponentLink(this);
    //AhmService.prototype.allComponentsDefinedAndInService('');
    AhmService.prototype.translateComponent(this, 'main-page');
  }

}
